import React from 'react';
import { CtaButton } from '../CtaButton';
import { CheckList } from '../CheckList';
import { finalChecks, images } from '../../data/offer';
export function FinalCta() {
  return <section className="w-full bg-navy px-4 py-16 sm:px-6 lg:py-24" aria-labelledby="final-title" data-id="element-124" data-mp="1nozqd7fngs78">
      <div className="mx-auto max-w-3xl text-center" data-id="element-125" data-mp="1so2qcdgrw88c">
        <h2 id="final-title" className="text-balance font-display text-[28px] font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-[44px]" data-id="element-126" data-mp="1smi0301hrbga">
          Bring More Structure to Your Clear Aligner Case-Planning Workflow
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-127" data-mp="14qdohqcb6x29">
          <p data-id="element-128" data-mp="19of3o06m6c8g">You do not need another collection of disconnected tips.</p>
          <p data-id="element-129" data-mp="2z452f21o833i">
            You need an organized way to review the information, objectives, movements, treatment stages, and follow-up considerations that make up a clear aligner case.
          </p>
          <p data-id="element-130" data-mp="294wu1deq7q2">
            The Clear Aligner Clinical Blueprint™ brings these topics together in six coordinated volumes, supported by five practical planning resources.
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white text-left" data-id="element-131" data-mp="b1f7fjs7sf7u">
          <img src={images.mockup} alt="Clear Aligner Clinical Blueprint complete digital collection" className="mx-auto w-full max-w-xl" data-id="element-132" data-mp="b3j8zv2n524y" />
          <div className="p-5 sm:p-8" data-id="element-133" data-mp="3ff4y24z4qjk3">
            <h3 className="text-center font-display text-lg font-extrabold uppercase text-navy" data-id="element-134" data-mp="3fg6lza18v0j8">Your complete digital collection includes:</h3>
            <div className="mx-auto mt-5 max-w-md" data-id="element-135" data-mp="3ogbj8rcq4ijo">
              <CheckList items={finalChecks} data-id="element-136" data-mp="3ohwdefv4lzh0" />
            </div>
            <p className="mt-7 text-center font-display text-xl font-extrabold text-navy sm:text-2xl" data-id="element-137" data-mp="3jgqiqchwo24u">
              Get the complete collection for just <span className="rounded-md bg-gold px-1.5" data-id="element-138" data-mp="13oj85ck9y7dt">$27 USD</span>
            </p>
            <p className="mt-1 text-center text-sm text-ink-muted" data-id="element-139" data-mp="yq7vyv6ibksf">One-time payment. Digital educational resource.</p>
            <CtaButton label="Yes! I want the Clear Aligner Clinical Blueprint™" className="mt-6" data-id="element-140" data-mp="3sippyxd8rlt0" />
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-xs leading-relaxed text-white/60" data-id="element-141" data-mp="5e9sydhjrcj5">
          Review all checkout terms, delivery information, and applicable policies before completing your purchase.
        </p>
      </div>
    </section>;
}